/* eslint-disable */

import React from 'react'
import {Link} from 'react-router-dom'
import SearchableCombo from '../BaseComponent/searchableCombo'
import http from '../Interceptor/Interseptor'
import jMoment from 'moment-jalaali'
import {DatePicker, MuiPickersUtilsProvider} from 'material-ui-pickers'
import JalaliUtils from 'material-ui-pickers-jalali-utils'
import {accounting} from 'accounting'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import {Icon, message} from 'antd'
import moment from 'moment'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import RETAIL from '../BaseComponent/RETAIL'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import Page from '../Pagination/Pagination'
import Loader from '../loaders/loader'
class FinancialSettlement extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedDateTo: moment(),
      drivers: [],
      driverId: '',
      showTable: false,
      objectSettle: {},
      unMatchCash: '',
      unMatchCard: '',
      modalInvoice: false,
      modalProducts: false,
      invoices: [],
      products: [],
      givenCashPayment: '',
      givenPosPayment: ''
    }
  }
  componentDidMount() {
    http
      .get(`${USER_MANAGE.USER_MANAGE_LIST_DRIVER}`, {})
      .then((response) => {
        if (response.data.error == null) {
          var result = response.data.object
          for (let i = 0; i < result.length; i++) {
            result[i]['value'] = result[i].personId
            result[i]['label'] = result[i].personId + ' - ' + result[i].name
          }

          this.setState({
            drivers: response.data.object
          })
        } else {
          // message.error(response.data.description)
          this.setState({
            drivers: []
          })
        }
        // alert(JSON.stringify(response.data))
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  handleDateChangeTo = (date) => {
    this.setState({selectedDateTo: date})
    // this.toDateInput.focus();
  }

  epochFrom = (x) => {
    var concatDayMount = x.split('/')
    var concatDate = concatDayMount[1] + concatDayMount[2]
    var constantDate = '0631'
    var n = concatDate.localeCompare(constantDate)

    let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let from = miladiDate + ' ' + '00:00:00'
    let fromEpoch = moment.utc(from).valueOf()
    if (n >= 0) {
      return fromEpoch - 3.5 * 3600 * 1000
    } else {
      return fromEpoch - 3.5 * 3600 * 1000
    }
  }

  epochTo = (x) => {
    var concatDayMount = x.split('/')
    var concatDate = concatDayMount[1] + concatDayMount[2]
    var constantDate = '0631'
    var n = concatDate.localeCompare(constantDate)

    let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let to = miladiDate + ' ' + '23:59:59'
    let toEpoch = moment.utc(to).valueOf()
    if (n >= 0) {
      return toEpoch - 3.5 * 3600 * 1000
    } else {
      return toEpoch - 3.5 * 3600 * 1000
    }
  }

  fromDate(props) {
    return <input className="form-control" {...props} />
  }
  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  getValueDriverId = (driverId) => {
    this.setState({
      driverId: driverId === null ? '' : driverId.personId
    })
  }

  searchSettlement() {
    var date = document.getElementById('date').value
    var driverId = this.state.driverId
    if (date === '') {
      message.error('تاریخ را مشخص کنید')
    } else if (driverId === '') {
      message.error('رساننده را مشخص کنید')
    } else {
      this.setState({
        fromDate: this.epochFrom(this.convertDigit(date)),
        toDate: this.epochTo(this.convertDigit(date)),
        driverId: driverId,
        loading: true
      })
      http
        .get(
          `${RETAIL.RETAIL_COMPANY_SETLLEMENT_PAYMENTS}?driverId=${driverId}&fromTime=${this.epochFrom(
            this.convertDigit(date)
          )}&toTime=${this.epochTo(this.convertDigit(date))}`,
          {}
        )
        .then((response) => {
          this.setState({
            loading: false
          })
          if (response.data.error === null) {
            this.setState({
              showTable: true,
              objectSettle: response.data.object
            })
          } else {
            message.error(response.data.description)
            this.setState({
              showTable: false,
              objectSettle: {}
            })
          }
        })
        .catch(() => {
          this.setState({
            loading: false
          })
        })
    }
  }

  invoiceList() {
    var {fromDate, toDate, driverId} = this.state
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    sessionStorage.setItem('params', `driverId=${driverId}&fromTime=${fromDate}&toTime=${toDate}`)

    http
      .get(
        `${
          REPORT_DISPATCH.REPORT_DISPATCH_SETTLEMENT_INVOICES
        }?export=false&pageNumber=1&pageSize=10&driverId=${driverId}&fromTime=${fromDate}&toTime=${toDate}`,
        {}
      )
      .then((response) => {
        if (response.data.error === null) {
          this.setState({
            invoices: response.data.object.result,
            countAllInvoice: response.data.object.countAll,
            modalInvoice: !this.state.modalInvoice
          })
        } else {
          message.error(response.data.description)
          this.setState({
            invoices: [],
            countAllInvoice: 0,
            modalInvoice: false
          })
        }
      })
  }
  cancelConfirm = () => {
    this.toogleInvoice()
  }
  toogleInvoice = () => {
    this.setState({
      modalInvoice: false
    })
  }

  productList() {
    var {fromDate, toDate, driverId} = this.state
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    sessionStorage.setItem('params', `driverId=${driverId}&fromTime=${fromDate}&toTime=${toDate}`)
    http
      .get(
        `${
          REPORT_DISPATCH.REPORT_DISPATCH_SETTLEMENT_INVOICEITEMS
        }?export=false&pageNumber=1&pageSize=10&driverId=${driverId}&fromTime=${fromDate}&toTime=${toDate}`,
        {}
      )
      .then((response) => {
        if (response.data.error === null) {
          this.setState({
            products: response.data.object.result,
            countAllProducts: response.data.object.countAll,
            modalProducts: !this.state.modalInvoice
          })
        } else {
          message.error(response.data.description)
          this.setState({
            products: [],
            countAllProducts: 0,
            modalProducts: false
          })
        }
      })
  }

  paginateProduct(data) {
    this.setState({
      products: data
    })
  }

  paginateInvoice(data) {
    this.setState({
      invoices: data
    })
  }

  toggleProduct = () => {
    this.setState({
      modalProducts: !this.state.modalProducts
    })
  }
  cancelProduct = () => {
    this.toggleProduct()
  }

  changeUnMatchCash = (e) => {
    let value = e.target.value
    let name = e.target.name
    if (value === '') {
      this.setState({
        unMatchCash: '',
        [name]: value
      })
    } else {
      this.setState({
        unMatchCash: Number(this.state.objectSettle.cashPayment) - Number(value),
        [name]: value
      })
    }
  }
  changeUnMatchCard = (e) => {
    let value = e.target.value
    let name = e.target.name

    if (value === '') {
      this.setState({
        unMatchCard: '',
        [name]: value
      })
    } else {
      this.setState({
        unMatchCard: Number(this.state.objectSettle.posPayment) - Number(value),
        [name]: value
      })
    }
  }

  confirmSettle = () => {
    var date = document.getElementById('date').value
    var driverId = this.state.driverId
    var debt = this.state.objectSettle.debt
    var lastSettle = this.state.objectSettle.lastSettle
    var cashPayment = this.state.objectSettle.cashPayment
    var posPayment = this.state.objectSettle.posPayment
    var otherPayment = this.state.objectSettle.otherPayment
    var remainedPayment = this.state.objectSettle.remainedPayment
    var completeDeliveredInvoiceCount = this.state.objectSettle.completeDeliveredInvoiceCount
    var incompleteDeliveredInvoiceCount = this.state.objectSettle.incompleteDeliveredInvoiceCount
    var returnedInvoiceCount = this.state.objectSettle.returnedInvoiceCount
    var rejectedInvoiceCount = this.state.objectSettle.rejectedInvoiceCount
    var {givenCashPayment, givenPosPayment} = this.state
    var dateError = false
    var driverError = false
    var givenCashError = false
    var givenPosError = false
    var formError = false
    if (date === '') {
      message.error('تاریخ را مشخص کنید')
      formError = true
      dateError = true
    } else {
      if (!dateError) {
        this.setState({
          error: ''
        })
      }
    }

    if (driverId === '') {
      driverError = true
      formError = true
      message.error('رساننده مشخص شود')
    } else {
      if (!driverError) {
        this.setState({
          error: ''
        })
      }
    }

    if (givenCashPayment === '') {
      givenCashError = true
      formError = true
      message.error('مبلغ نقدی دریافتی پر شود')
    } else {
      if (!givenCashError) {
        this.setState({
          error: ''
        })
      }
    }

    if (givenPosPayment === '') {
      givenPosError = true
      formError = true
      message.error('مبلغ کارتخوان پر شود')
    } else {
      if (!givenPosError) {
        this.setState({
          error: ''
        })
      }
    }
    if (!formError) {
      let existData = {
        driverId,
        fromTime: this.epochFrom(this.convertDigit(date)),
        toTime: this.epochTo(this.convertDigit(date))
      }
      http.post(`${RETAIL.RETAIL_COMPANY_SETLLEMENT_EXIST}`, existData, {}).then((response) => {
        if (response.data.error === null) {
          if (response.data.object) {
            if (confirm('سند تسویه در این تاریخ برای این راننده ثبت شده است.آیا اطمینان دارید؟؟؟')) {
              let data = {
                driverId,
                fromTime: this.epochFrom(this.convertDigit(date)),
                toTime: this.epochTo(this.convertDigit(date)),
                debt,
                lastSettle,
                cashPayment,
                posPayment,
                otherPayment,
                remainedPayment,
                givenCashPayment: this.convertDigit(givenCashPayment),
                givenPosPayment: this.convertDigit(givenPosPayment),

                completeDeliveredInvoiceCount,
                incompleteDeliveredInvoiceCount,
                returnedInvoiceCount,
                rejectedInvoiceCount
              }
              http.post(`${RETAIL.RETAIL_COMPANY_SETLLEMENT_CONFIRM}`, data, {}).then((response) => {
                if (response.data.error === null) {
                  message.success('عملیات با موفقیت انجام شد . لطفا صبر کنید')
                  setTimeout(() => {
                    window.location.assign('/report/settlement/drivers')
                  }, 2000)
                } else {
                }
              })
            }
          } else {
            let data = {
              driverId,
              fromTime: this.epochFrom(this.convertDigit(date)),
              toTime: this.epochTo(this.convertDigit(date)),
              debt,
              lastSettle,
              cashPayment,
              posPayment,
              otherPayment,
              remainedPayment,
              givenCashPayment: this.convertDigit(givenCashPayment),
              givenPosPayment: this.convertDigit(givenPosPayment),

              completeDeliveredInvoiceCount,
              incompleteDeliveredInvoiceCount,
              returnedInvoiceCount,
              rejectedInvoiceCount
            }
            http.post(`${RETAIL.RETAIL_COMPANY_SETLLEMENT_CONFIRM}`, data, {}).then((response) => {
              if (response.data.error === null) {
                message.success('عملیات با موفقیت انجام شد . لطفا صبر کنید')
                setTimeout(() => {
                  window.location.assign('/report/settlement/drivers')
                }, 2000)
              } else {
              }
            })
          }
        } else {
        }
      })
    }
  }

  render() {
    let pageNumber = sessionStorage.getItem('pageNumber')
    let dropDownVal = sessionStorage.getItem('dropDownVal')
    return (
      <div className="rtl">
        <Loader show={this.state.loading} />
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>تسویه رساننده</li>
          </ul>
          <div className="basketFilterComponent" style={{marginTop: '10px'}}>
            <div className="filterInputs">
              <div className="formComponent">
                <label>تاریخ :</label>
                <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                  <DatePicker
                    okLabel="تأیید"
                    cancelLabel="لغو"
                    autoOk={true}
                    leftArrowIcon={<Icon type="left" />}
                    rightArrowIcon={<Icon type="right" />}
                    labelFunc={(date) => (date == null ? '' : date.format('jYYYY/jMM/jDD'))}
                    onChange={this.handleDateChangeTo}
                    TextFieldComponent={this.fromDate}
                    id="date"
                    name="date"
                    value={this.state.selectedDateTo}
                    readOnly
                  />
                </MuiPickersUtilsProvider>
              </div>

              <div className="formComponent">
                <SearchableCombo
                  options={this.state.drivers}
                  getValueCombo={this.getValueDriverId}
                  lableText="رساننده"
                  placeholder="------"
                  isClearable={true}
                  isMulti={false}
                  isDisabled={false}
                />
              </div>
              <div className="formComponent">
                <label className="hiddenLabel">sdfdsf</label>
                <span onClick={this.searchSettlement.bind(this)} className="searchCRM">
                  جست و جو
                </span>
              </div>

              <div className="formComponent" style={this.state.showTable ? {display: 'block'} : {display: 'none'}}>
                <label className="hiddenLabel">sdfdsf</label>
                <span onClick={this.invoiceList.bind(this)} className="searchCRM long">
                  لیست فاکتور های تحویل نشده یا ناقص تحویل شده
                </span>
              </div>

              <div className="formComponent" style={this.state.showTable ? {display: 'block'} : {display: 'none'}}>
                <label className="hiddenLabel">sdfdsf</label>
                <span onClick={this.productList.bind(this)} className="searchCRM long">
                  لیست کالا های تحویل نشده یا ناقص تحویل شده
                </span>
              </div>
            </div>
          </div>
          <form
            className="basketFilterComponent factorForm"
            style={this.state.showTable ? {display: 'block'} : {display: 'none'}}
          >
            <table className="baseTable">
              <thead>
                <tr>
                  <td colSpan={7}>
                    <span className="customBadge badge  badge-primary">
                      تعداد فاکتور :{' '}
                      {Number(this.state.objectSettle.completeDeliveredInvoiceCount) +
                        Number(this.state.objectSettle.incompleteDeliveredInvoiceCount) +
                        this.state.objectSettle.returnedInvoiceCount +
                        Number(this.state.objectSettle.rejectedInvoiceCount)}
                    </span>
                    <span className="customBadge badge  badge-success">
                      تعداد فاکتور تحویل شده : {this.state.objectSettle.completeDeliveredInvoiceCount}
                    </span>
                    <span className="customBadge badge  badge-warning">
                      تعداد فاکتور تحویل ناقص : {this.state.objectSettle.incompleteDeliveredInvoiceCount}
                    </span>
                    <span className="customBadge badge  badge-warning">
                      تعداد فاکتور مرجوع شده : {this.state.objectSettle.rejectedInvoiceCount}
                    </span>
                    <span className="customBadge badge badge-danger">
                      تعداد فاکتور تحویل نشده : {this.state.objectSettle.returnedInvoiceCount}
                    </span>
                  </td>
                </tr>
              </thead>
              <tbody>
                {/* <tr className='firstRow'>
                                <td rowSpan={2}>در سیستم</td>
                                <td>بدهکار</td>
                                <td>تسویه از قبل</td>
                                <td>پرداخت نقدی</td>
                                <td>پرداخت کارتخوان</td>
                                <td>پرداخت از قبل</td>
                                <td>مانده</td>
                            </tr>
                            <tr>
                                <td className='priceCell'>{accounting.formatMoney(this.state.objectSettle.debt,'',',')}</td>
                                <td className='priceCell'>{accounting.formatMoney(this.state.objectSettle.lastSettle,'',',')}</td>
                                <td className='priceCell'>{accounting.formatMoney(this.state.objectSettle.cashPayment,'',',')}</td>
                                <td className='priceCell'>{accounting.formatMoney(this.state.objectSettle.posPayment,'',',')}</td>
                                <td className='priceCell'>{accounting.formatMoney(this.state.objectSettle.otherPayment,'',',')}</td>
                                <td className='priceCell'>{accounting.formatMoney(this.state.objectSettle.remainedPayment,'',',')}</td>
                            </tr> */}
                <tr>
                  <td rowSpan={2}>تحویلی</td>
                  <td colSpan={2} />
                  <td className="priceCell" style={{width: '200px'}}>
                    <label>دریافتی نقد : </label>
                    <input
                      name={'givenCashPayment'}
                      autoComplete="off"
                      placeholder="مبلغ به ریال"
                      onChange={this.changeUnMatchCash}
                      type={'text'}
                      className="form-control"
                    />
                  </td>
                  <td className="priceCell" style={{width: '200px'}}>
                    <label>دریافتی کارتخوان : </label>
                    <input
                      name={'givenPosPayment'}
                      autoComplete="off"
                      placeholder="مبلغ به ریال"
                      onChange={this.changeUnMatchCard}
                      type={'text'}
                      className="form-control"
                    />
                  </td>
                  <td colSpan={2} />
                </tr>
                <tr>
                  <td colSpan={2}>مغایرت</td>
                  <td className="priceCell" style={{width: '200px'}}>
                    {accounting.formatMoney(this.state.unMatchCash, '', ',')}
                  </td>
                  <td className="priceCell" style={{width: '200px'}}>
                    {accounting.formatMoney(this.state.unMatchCard, '', ',')}
                  </td>
                  <td colSpan={1}>
                    <span className="btn btn-sm confirmSettle" onClick={this.confirmSettle}>
                      تایید
                    </span>
                  </td>
                  <td />
                </tr>
              </tbody>
            </table>
          </form>
        </div>
        <Modal isOpen={this.state.modalInvoice} toggle={this.toogleInvoice} size="lg">
          <ModalHeader toggle={this.toogleInvoice}>
            <p>لیست فاکتور ها</p>
          </ModalHeader>
          <ModalBody>
            <div>
              <table className="baseTable">
                <tr className="firstRow">
                  <td>ردیف</td>
                  <td>شناسه فاکتور</td>
                  <td>شماره فاکتور</td>
                  <td> خریدار</td>
                  <td> کد مشتری</td>
                  <td> تحویل گیرنده</td>
                  <td>موبایل</td>
                  <td>وضعیت پرداخت</td>
                  <td>وضعیت تایید</td>
                  <td>تاریخ تایید</td>
                  <td>تاریخ ثبت</td>
                  <td>پرداخت در محل</td>
                  <td className="priceCell">قابل پرداخت</td>
                </tr>
                {this.state.invoices.map((items, index) => (
                  <tr>
                    <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                    <td>{items.invoiceId}</td>
                    <td>{items.invoiceNum}</td>
                    <td>{items.buyerName}</td>
                    <td>{items.userCode}</td>
                    <td>{items.recipientName}</td>
                    <td className="mobileTD">{items.mobile == null ? '-' : items.mobile.replace(/\+98/g, '0')}</td>
                    <td className="smallPhoto">
                      {items.paid ? (
                        <img src={require('../../image/confirm.svg')} />
                      ) : (
                        <img src={require('../../image/ignor.svg')} />
                      )}
                    </td>
                    <td className="smallPhoto">
                      {items.confirmed ? (
                        <img src={require('../../image/confirm.svg')} />
                      ) : (
                        <img src={require('../../image/ignor.svg')} />
                      )}
                    </td>
                    <td>
                      {items.confirmDate == null ? '-' : jMoment(items.confirmDate).format('jYYYY/jMM/jDD HH:mm')}
                    </td>
                    <td>
                      {items.registerDate == null ? '-' : jMoment(items.registerDate).format('jYYYY/jMM/jDD HH:mm')}
                    </td>
                    <td>{items.payOnDelivery ? 'بله' : 'خیر'}</td>
                    <td className="priceCell">{accounting.formatMoney(items.payableAmount, '', ',')}</td>
                  </tr>
                ))}
              </table>
              <div className="paginationWrapp">
                <Page
                  defaultCurrent={1}
                  total={this.state.countAllInvoice}
                  onResultFetched={this.paginateInvoice.bind(this)}
                  urlParams={''}
                  url={REPORT_DISPATCH.REPORT_DISPATCH_SETTLEMENT_INVOICES}
                />
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="cancelBtnModal" onClick={this.cancelConfirm}>
              بستن
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.modalProducts} toggle={this.toggleProduct} size="lg">
          <ModalHeader toggle={this.toggleProduct}>
            <p>لیست کالا ها</p>
          </ModalHeader>
          <ModalBody>
            <div>
              <table className="baseTable">
                <tr className="firstRow">
                  <td>ردیف</td>
                  <td>شناسه فاکتور</td>
                  <td>کد محصول</td>
                  <td>نام محصول</td>
                  <td>بارکد محصول</td>
                  <td>واحد محصول</td>
                  <td>قیمت واحد</td>
                  <td>قیمت کل</td>
                  <td>قابل پرداخت</td>
                </tr>
                {this.state.products.map((items, index) => (
                  <tr>
                    <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                    <td>{items.invoiceId}</td>
                    <td>{items.articleId}</td>
                    <td>{items.productName}</td>
                    <td>{items.productCode}</td>
                    <td>{items.productUnitTitle}</td>
                    <td className="priceCell">{accounting.formatMoney(items.unitPrice, '', ',')}</td>
                    <td className="priceCell">{accounting.formatMoney(items.totalAmount, '', ',')}</td>
                    <td className="priceCell">{accounting.formatMoney(items.payableAmount, '', ',')}</td>
                  </tr>
                ))}
              </table>
              <div className="paginationWrapp">
                <Page
                  defaultCurrent={1}
                  total={this.state.countAllProducts}
                  onResultFetched={this.paginateProduct.bind(this)}
                  urlParams={sessionStorage.getItem('params')}
                  url={REPORT_DISPATCH.REPORT_DISPATCH_SETTLEMENT_INVOICEITEMS}
                />
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="cancelBtnModal" onClick={this.cancelProduct}>
              بستن
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}
export default FinancialSettlement
